import React from "react";
import "./QuestionModal.css";
import { DeleteIcon, EditIcon } from "../../../../icons/reactIcons";

interface ViewQuestionModalProps {
  open: boolean;
  onClose: () => void;
  onEdit: () => void;
  onDelete: () => void;
  question: {
    questionName: string;
    options: {
      id: string;
      optionName: string;
      optionOrder?: number;
    }[];
  };
}

const ViewQuestionModal: React.FC<ViewQuestionModalProps> = ({
  open,
  onClose,
  onEdit,
  onDelete,
  question,
}) => {
  if (!open) return null;

  console.log("question", question);

  return (
    <div className="questionModal-overlay">
      <div className="questionModal-container">
        <div className="questionModal-header">
          <h3>Question</h3>
          <div className="questionModal-icons">
            <button onClick={onDelete} className="icon-btn delete">
              <DeleteIcon />
            </button>
            <button onClick={onEdit} className="icon-btn edit">
              <EditIcon />
            </button>
          </div>
        </div>

        <div className="view-questionModal-body">
          <div className="questionModal-row">
            <label className="questionModal-label">Name</label>
            <p className="questionModal-value">{question.questionName}</p>
          </div>

          <hr className="questionModal-divider" />

          {question.options.map((ans, i) => (
            <div key={ans?.id} className="questionModal-row">
              <label className="questionModal-label">Answer {i + 1}</label>
              <p className="questionModal-value bold">{ans.optionName}</p>
            </div>
          ))}
        </div>

        <div className="questionModal-footer">
          <button onClick={onClose} className="btn cancel">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewQuestionModal;
